import { EnvxSchema, EnvxType, EnvxVarSchema } from "../types";

function tsTypeFromEnvxType(type: EnvxType, schema: EnvxVarSchema): string {
  switch (type) {
    case "string":
    case "email":
    case "url":
      return "string";
    case "number":
      return "number";
    case "boolean":
      return "boolean";
    case "enum":
      return schema.values && schema.values.length > 1
        ? schema.values.map((v) => `"${v}"`).join(" | ")
        : "string";
    default:
      return "any";
  }
}

/**
 * creates a typescript interface for each variable according to the schema structure, which is important because it can be used with getEnvx
 */
export function generateTypesFromEnvx(schema: EnvxSchema): string {
  let lines: string[] = [];

  lines.push(`// AUTO GENERATED FILE - DO NOT EDIT`);
  lines.push(`//`);
  lines.push(
    `// This file is auto-generated from your environment schema (.envx).`
  );
  lines.push(
    `// It defines the TypeScript interface for your environment variables,`
  );
  lines.push(
    `// allowing you to use it with getEnvx or similar functions to get`
  );
  lines.push(`// fully typed and validated environment configs.`);
  lines.push(`//`);
  lines.push(`// Usage example:`);
  lines.push(`//`);
  lines.push(`// import { getEnv } from "typenvx";`);
  lines.push(`// import type { EnvVars } from "./envx.ts";`);
  lines.push(`//`);
  lines.push(`// const env = getEnv<EnvVars>();`);
  lines.push(`// console.log(env.API_URL); // typed as string`);
  lines.push(`//`);
  lines.push(`// NOTE:`);
  lines.push(`// - Optional variables are marked with '?'.`);
  lines.push(`// - Enum variables are typed as string literals.`);
  lines.push(`//`);
  lines.push(`// Keep this file updated by regenerating after schema changes.`);
  lines.push(`\nexport interface EnvVars {`);

  for (const key in schema) {
    const { type = "string", required } = schema[key];
    const tsType = tsTypeFromEnvxType(type, schema[key]);
    const optionalFlag = required ? "" : "?";
    lines.push(`  ${key}${optionalFlag}: ${tsType};`);
  }
  
  lines.push(`}\n`);
  return lines.join("\n");
}
